<template>
  <div>
    <v-container class="sticky-breadcrumbs">
      <v-breadcrumbs>
        <v-breadcrumbs-item exact :to="{path: '/portal/subscriptions/'+this.activeSubscriptionId+'/home'}">Home</v-breadcrumbs-item>
        <v-breadcrumbs-divider>
          <v-icon>mdi-chevron-right</v-icon>
        </v-breadcrumbs-divider>
        <v-breadcrumbs-item disabled>{{getPuzzleName(puzzle_order_id)}}</v-breadcrumbs-item>
      </v-breadcrumbs>
    </v-container>
    <v-container>
      <v-row>
        <v-col class="col-3">
          <v-img
              :src="getPuzzleMediumImageSrc(puzzle_order_id)"
              class="grey darken-4"
          ></v-img>
          <small>
            <v-icon>mdi-magnify-plus-outline</v-icon>
            expand image
          </small>
        </v-col>
        <v-col>
          <h3>{{getPuzzleName(puzzle_order_id)}}</h3>
          <p>{{getBrandName(puzzle_order_id)}}</p>
          <ratings-display :puzzle-order-id="puzzle_order_id"></ratings-display>
        </v-col>
      </v-row>
      <hr class="mt-5 mb-5"/>
      <!--      <puzzling-sessions :puzzle-order-id="puzzle_order_id" >-->
      <!--      </puzzling-sessions>-->
      <!--      <hr class="mt-5 mb-5"/>-->
      <v-row>

        <v-col></v-col>
      </v-row>
      <h3>
        Puzzle Feedback
      </h3>
      <feedback-display :puzzle-order-id="this.puzzle_order_id"></feedback-display>
    </v-container>

  </div>
</template>

<script>
import {mapState} from "vuex";
import {mapGetters} from "vuex";

import ratingsDisplay from "./history/ratings_display"
import feedbackDisplay from "./history/feedback_display"
import puzzlingSessions from "./history/puzzling_sessions"

export default {
  name: 'puzzle_order',
  components: {
    feedbackDisplay, ratingsDisplay, puzzlingSessions
  },
  methods: {
    getPuzzleName(puzzleOrderId) {
      return this.puzzleProducts[this.puzzles[this.puzzleOrders[puzzleOrderId].attributes.puzzleId].attributes.puzzleProductId].attributes.name
    },
    getPuzzleMediumImageSrc: function(puzzleOrderId){
      return this.puzzleProducts[this.puzzles[this.puzzleOrders[puzzleOrderId].attributes.puzzleId].attributes.puzzleProductId].attributes.mediumImageSrc;
    },
    getBrandName: function(puzzleOrderId){
      return this.brands[this.puzzleProducts[this.puzzles[this.puzzleOrders[puzzleOrderId].attributes.puzzleId].attributes.puzzleProductId].attributes.brandId].attributes.name
    }
  },
  watch: {
    hasReviewsFeature: {
      handler(value) {
        if (value === false) {
          this.$router.replace('/portal/subscriptions/'+this.activeSubscriptionId+'/home')
        }
      },
      immediate: true
    }
  },
  created: function(){
  },
  mounted: function(){
  },
  computed: {
    ...mapState({
    }),
    ...mapGetters({
      puzzleOrders: 'getAllPuzzleOrders',
      puzzles: 'getPuzzles',
      brands: 'getBrands',
      puzzleProducts: 'getPuzzleProducts',
      activeSubscription: 'getActiveSubscription',
      activeSubscriptionId: 'getActiveSubscriptionId',
      hasReviewsFeature: 'hasReviewsFeature',
    }),
  },
  props: {
    puzzle_order_id: null,
  }
}
</script>
<style scoped>
.active {
  border: 2px solid #4caf50 !important;
}
</style>
